<template>
  <div class="ChangePassword">
    <yd-navbar title="设备管理">
      <template slot="left">
        <router-link to="/user">
          <yd-navbar-back-icon></yd-navbar-back-icon>
        </router-link>
      </template>
    </yd-navbar>

    <div class="list">
      <div class="item">
        <input placeholder="姓名" v-model="name" />
      </div>
      <div class="item">
        <input placeholder="电话" v-model="phone" />
      </div>
      <div class="item">
        <input placeholder="更换原因" v-model="yy" />
      </div>
    </div>
    <div class="confirmBnt bg-color-red" @click="xiugai">提交审核</div>
  </div>
</template>
<style scoped>
.ChangePassword .phone input {
  width: 2rem;
  text-align: center;
  background-color: #fff;
}
.codeVal {
  width: 1.5rem;
  height: 0.5rem;
}
.codeVal img {
  width: 100%;
  height: 100%;
}
</style>
<script>
// import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

import { postSheBei } from "@api/store";
import { VUE_APP_API_URL } from "@utils";

export default {
  name: "ChangeShebei",
  components: {},
  props: {},
  data: function() {
    return {
      user: "",
      name: "",
      phone: "", //隐藏几位数的手机号；
      yy: ""
    };
  },
  mixins: [sendVerifyCode],
  // computed: mapGetters(["userInfo"]),
  mounted: function() {
    let vm = this;
    let info = JSON.parse(localStorage.getItem("uinfo"));
    this.user = info;
    console.log("info:", info);
    this.phone = info.phone;
    this.name = info.nickname;

    plus.key.addEventListener(
      "backbutton",
      function() {
        vm.$router.push({ path: "/user/data" });
      },
      false
    );
  },
  methods: {
    xiugai() {
      console.log(this.password, this.password2);
      let uid = localStorage.getItem("uid");

      if (!this.name) {
        this.$dialog.toast({
          mes: "请输入名称",
          timeout: 1500
        });
        return;
      }
      if (this.phone.length != 11) {
        this.$dialog.toast({
          mes: "请输入正确的手机号",
          timeout: 1500
        });
        return;
      }
      if (!this.yy) {
        this.$dialog.toast({
          mes: "请输入理由",
          timeout: 1500
        });
        return;
      }

      postSheBei({
        uid: uid,
        real_name: this.name,
        phone: this.phone,
        mark: this.yy
      })
        .then(res => {
          console.log("修改:", res);
          let that = this;
          if (res.status == 200) {
            this.$dialog.toast({
              mes: "成功提交",
              timeout: 1500
            });
          }
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
      console.log(this.codeUrl);
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    getUserInfo: function() {
      let that = this;
      getUserInfo().then(res => {
        that.yphone = res.data.phone;
        let reg = /^(\d{3})\d*(\d{4})$/;
        that.phone = that.yphone.replace(reg, "$1****$2");
      });
    },
    async confirm() {
      let that = this;
      const { password, password2, captcha, codeVal } = that;
      try {
        await that
          .$validator({
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            codeVal: this.isShowCode
              ? [
                  required(required.message("验证码")),
                  attrs.length(4, attrs.length.message("验证码")),
                  alpha_num(alpha_num.message("验证码"))
                ]
              : []
          })
          .validate({ password, captcha, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (password !== password2) return that.$dialog.error("两次密码不一致");
      registerReset({
        account: that.yphone,
        captcha: that.captcha,
        password: that.password,
        code: that.codeVal
      })
        .then(res => {
          that.$dialog.success(res.msg).then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { yphone, codeVal } = that;
      try {
        await that
          .$validator({
            yphone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ yphone, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: yphone, key: that.keyCode, code: that.codeVal })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
